import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  class: "edit-1_svg__edit-1",
  fill: "none",
  viewBox: "0 0 36 36"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    opacity: ".4",
    d: "M16.824 2.065h-6.34C5.269 2.065 2 5.757 2 10.983v14.1C2 30.308 5.254 34 10.484 34h14.963c5.232 0 8.486-3.692 8.486-8.918v-6.83",
    stroke: "currentColor",
    "stroke-width": "2.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "clip-rule": "evenodd",
    d: "M12.306 15.855L24.979 3.183a4.045 4.045 0 015.716 0l2.064 2.064a4.042 4.042 0 010 5.716L20.025 23.697a3.681 3.681 0 01-2.603 1.078H11.07l.16-6.41a3.68 3.68 0 011.076-2.51z",
    stroke: "currentColor",
    "stroke-width": "2.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M23.053 5.14l7.743 7.744",
    stroke: "currentColor",
    "stroke-width": "2.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_2 = [
  _hoisted_1
]

interface Props {
    size: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'IconEditProfile',
  props: {
    size: null
  },
  setup(__props: any) {

const props = __props as {
    size: string
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("i", {
    class: _normalizeClass([__props.size, "text-primary300 block mx-auto"])
  }, _hoisted_2, 2))
}
}

})